import React from "react";
import BookingSummaryShared, {
  AdditionalService,
} from "../common/components/BookingSummary/BookingSummaryShared";
import { useEventFlowUseCase } from "./eventFlowUseCase";

interface BookingSummaryProps {
  roomImage: string;
  roomTitle: string;
  address: string;
  numberOfGuests: number;
  additionalServices: AdditionalService[];
}

/**
 * #1713 part 3: the summary displays the SERVER's quote
 * (`POST /app/price-preview`). The weekday/weekend count and the
 * `Math.ceil(weekends / 3)` weekend formula that lived here — the #863
 * known-wrong placeholder — are gone with the rest of the client price
 * computation; `BookingSummaryShared` fetches and renders the breakdown,
 * and the weekend semantics are now solely the server resolver's
 * (`shared/pricing/venue-rate-vectors.json`).
 */
const BookingSummary: React.FC<BookingSummaryProps> = ({
  roomImage,
  roomTitle,
  address,
  numberOfGuests,
  additionalServices,
}) => {
  const useCase = useEventFlowUseCase();
  return (
    <BookingSummaryShared
      roomImage={roomImage}
      roomTitle={roomTitle}
      address={address}
      numberOfGuests={numberOfGuests}
      additionalServices={additionalServices}
      showAdditionalServices
      useCase={useCase}
    />
  );
};

export default BookingSummary;
